module.exports = __webpack_public_path__ + "img/article_outlined.923e2c7c.svg";